export default __webpack_public_path__ + "static/media/GR Thanga Maligai.d72c1ce8.png";